import {takeEvery, select, putResolve, call, delay} from 'redux-saga/effects';
import {getLocationFailure, getLocationRequest, getLocationSuccess} from 'new-actions/geolocation.actions';
import {getLocation} from 'helpers/geolocation.helper';
import {
	ASK_LOCATION_PERMISSION_SUCCESS,
	LOAD_LOCATION_PERMISSION_STATUS_SUCCESS,
} from 'new-constants/permission.constants';
import {NativePermissionStatuses} from 'new-constants/common.constants';

function* refreshGeolocation() {
	yield delay(100);
	const state = yield select();
	if (!state.permission.location.isGranted) return;

	yield putResolve(getLocationRequest());

	let location = null;

	try {
		location = yield call(getLocation);
	} catch (e) {
		yield putResolve(getLocationFailure(e?.message));
		return;
	}

	if (location?.coords) {
		yield putResolve(getLocationSuccess(location.coords.latitude, location.coords.longitude, location.timestamp));
	} else {
		yield putResolve(getLocationFailure());
	}
}

export const geolocationSaga = function* geolocationSaga() {
	yield takeEvery(
		action =>
			[LOAD_LOCATION_PERMISSION_STATUS_SUCCESS, ASK_LOCATION_PERMISSION_SUCCESS].includes(action.type) &&
			(action.status === NativePermissionStatuses.GRANTED ||
				action.status === NativePermissionStatuses.GRANTED_WHEN_IN_USE),
		refreshGeolocation
	);
};
